import tracker from '@beastshop/tracker-m'
export default tracker



// WEBPACK FOOTER //
// ./static/track/index.js